module.exports = __webpack_public_path__ + "static/media/audio_card.664ba616.png";